import { useRef } from "react";
import "./CardCentros.css";

const CardCentros = ({ centro, ubicacion, texto, coordenadaGps }) => {
  const trackButton = useRef();

  return (
    <div ref={trackButton}>
      <div className="ptur-atencionSinTurno-cardBody">
        <div className="ptur-atencionSinTurno-textoCard">
          <div className="ptur-atencionSinTurno-centro-direccion">
            <p className="rb18b">{centro}</p>
            <a href={`https://maps.google.com/?q=${coordenadaGps}`}>{ubicacion}</a>
            <p>
              <b>Horarios de atención:</b>
            </p>
          </div>
          <div className="ptur-atencionSinTurno-horario content"
          dangerouslySetInnerHTML={{ __html: texto }}>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardCentros;
